
export { default as add } from "./add.js"
export { default as allPass } from "./allPass.js"
export { default as always } from "./always.js"
export { default as anyPass } from "./anyPass.js"
export { default as compose } from "./compose.js"
export { default as ifElse } from "./ifElse.js"
export { default as pathEq } from "./pathEq.js"